<!-- eslint-disable vue/no-parsing-error -->
<template>
  <div class="Non-Qualification-Vendor-Page">
    <div v-loading.fullscreen.lock="fullscreenLoading"></div>
    <!-- 招標案件編輯主畫面 -->
    <el-form ref="form" :model="form" class="form" label-position="top">
      <!-- <el-form-item label="廠別">
        <el-input v-model="form.factoryId" disabled></el-input>
      </el-form-item> -->
      <label>{{ VersionText }}</label>
      <el-form-item :label="isVietnam ? 'Nhà máy / Factory' : '廠別 / Factory'">
        <el-input
          v-if="form.factoryId === 'KH'"
          value="高雄廠(KH)"
          disabled
        ></el-input>
        <el-input
          v-if="form.factoryId === 'SZ'"
          value="蘇州廠(SZ)"
          disabled
        ></el-input>
        <el-input
          v-if="form.factoryId === 'NJ'"
          value="南京廠(NJ)"
          disabled
        ></el-input>
        <el-input
          v-if="form.factoryId === 'GZ'"
          value="廣州廠(GZ)"
          disabled
        ></el-input>
        <el-input
          v-if="form.factoryId === 'KW'"
          value="高雄廠(KW)"
          disabled
        ></el-input>
        <el-input
          v-if="form.factoryId === 'VH'"
          value="Phải điền(VH)"
          disabled
        ></el-input>
      </el-form-item>

      <el-form-item
        :label="isVietnam ? 'Mục đích đăng kí / Application purpose' : '申請目的 / Application purpose'"
        prop="applicationPurpose"
        :rules="{
          required: true,
          message: isVietnam ? 'Phải điền / Required fields' : '必填 / Required fields',
          trigger: ['blur', 'change'],
        }"
      >
        <el-radio-group v-model="form.applicationPurpose">
          <el-radio label="0">{{ isVietnam ? 'Báo giá / Quotation' : '報價用 / Quotation' }}</el-radio>
          <el-radio label="1">{{ isVietnam ? 'Hình ảnh / Drawing' : '圖面用 / Drawing' }}</el-radio>
          <el-checkbox v-if="checked" v-model="checked" disabled
            >同意NDA</el-checkbox
          >
        </el-radio-group>
      </el-form-item>

      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item
            :label="
              form.applicationPurpose === '0'
              ? isVietnam ? 'Tên nhân viên mua hàng ROE / ROE purcher name' : '瑞儀採購人員姓名 / ROE purcher name'
              : isVietnam ? 'Tên kỹ sư ROE / ROE engineer name' : '瑞儀工程師姓名 / ROE engineer name'
            "
            prop="radiantUserName"
            :rules="{
              required: true,
              message: isVietnam ? 'Phải điền / Required fields' : '必填 / Required fields',
              trigger: ['blur', 'change'],
            }"
          >
            <el-input v-model="form.radiantUserName"></el-input>
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item
            :label="isVietnam ? 'Số máy nhánh / Extension number' : '分機號碼 / Extension number'"
            prop="radiantUserNameExt"
            :rules="{
              required: true,
              message: isVietnam ? 'Phải điền / Required fields' : '必填 / Required fields',
              trigger: ['blur', 'change'],
            }"
          >
            <el-input v-model="form.radiantUserNameExt"></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-form-item
        :label="isVietnam ? 'Tên nhà cung cấp / Vendor name' : '廠商名稱 / Vendor name'"
        prop="vendorName"
        :rules="{
          required: true,
          message: isVietnam ? 'Phải điền / Required fields' : '必填 / Required fields',
          trigger: ['blur', 'change'],
        }"
      >
        <el-input v-model="form.vendorName"></el-input>
      </el-form-item>

      <el-form-item
        :label="isVietnam ? 'Mã số thống nhất (mã số thuế) / Unified number (tax registration number)' : '統一編號(稅籍編號) / Unified number (tax registration number)'"
        prop="taxId"
        :rules="{
          required: true,
          message: isVietnam ? 'Phải điền / Required fields' : '必填 / Required fields',
          trigger: ['blur', 'change'],
        }"
      >
        <el-input v-model="form.taxId"></el-input>
      </el-form-item>

      <el-form-item
        :label="isVietnam ? 'Điện thoại công ty / Company phone' : '公司電話 / Company phone'"
        prop="vendorTelephone"
        :rules="{
          required: true,
          message: isVietnam ? 'Phải điền / Required fields' : '必填 / Required fields',
          trigger: ['blur', 'change'],
        }"
      >
        <el-input v-model="form.vendorTelephone"></el-input>
      </el-form-item>
      <el-form-item
        :label="isVietnam ? 'Địa chỉ công ty / Company address' : '公司地址 / Company address'"
        prop="vendorAddress"
        :rules="{
          required: true,
          message: isVietnam ? 'Phải điền / Required fields' : '必填 / Required fields',
          trigger: ['blur', 'change'],
        }"
      >
        <el-input v-model="form.vendorAddress"></el-input>
      </el-form-item>
      <el-form-item
        :label="isVietnam ? 'Địa chỉ hoá đơn / Invoice address' : '發票地址 / Invoice address'"
        prop="invoiceAddress"
        :rules="{
          required: true,
          message: isVietnam ? 'Phải điền / Required fields' : '必填 / Required fields',
          trigger: ['blur', 'change'],
        }"
      >
        <el-input v-model="form.invoiceAddress"></el-input>
      </el-form-item>
      <el-form-item label="退件原因" v-if="!isNew">
        <el-input v-model="form.vetoNote" disabled></el-input>
      </el-form-item>
      <el-row
        :gutter="20"
        v-for="(email, index) in form.nonQualificationVendorDetails"
        :key="index"
        class="email-list"
      >
        <el-col :span="10">
          <el-form-item
            :label="isVietnam ? 'Tên / Name' : '姓名 / Name'"
            :prop="'nonQualificationVendorDetails.' + index + '.userName'"
            :rules="{
              required: true,
              message: isVietnam ? 'Phải điền / Required fields' : '必填 / Required fields',
              trigger: ['blur', 'change'],
            }"
          >
            <el-input v-model="email.userName"></el-input>
          </el-form-item>
        </el-col>

        <el-col :span="10">
          <el-form-item
            label="Email"
            :prop="'nonQualificationVendorDetails.' + index + '.userE_Mail'"
            :rules="[
              { required: true, message: isVietnam ? 'Phải điền / Required fields' : '必填 / Required fields', trigger: ['blur', 'change'] },
              {
                type: 'email',
                message: '請輸入正確格式',
                trigger: ['blur', 'change'],
              },
            ]"
          >
            <el-input v-model="email.userE_Mail"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-button
            type="danger"
            v-if="form.nonQualificationVendorDetails.length !== 1"
            icon="el-icon-delete"
            circle
            @click.prevent="removeEmail(index)"
          ></el-button>
          <el-button
            v-if="form.nonQualificationVendorDetails.length === index + 1"
            type="primary"
            icon="el-icon-plus"
            circle
            @click.prevent="addEmail()"
          ></el-button>
        </el-col>
      </el-row>

      <!-- Modal -->
      <div
        class="modal fade"
        id="contractModal"
        tabindex="-1"
        role="dialog"
        aria-hidden="true"
        data-backdrop="static"
        data-keyboard="false"
      >
        <div
          class="modal-dialog modal-xl modal-dialog-scrollable"
          role="document"
        >
          <div class="modal-content">
            <div class="modal-body">
              <template v-if="language === 'TW'">
                <h4 class="text-center">供應商保密義務聲明</h4>
                <p style="text-indent: 2em;">
                  基於雙方間業務往來之目的（以下簡稱「業務往來」），而本公司(以下簡稱「甲方」)取得瑞儀光電有限公司(以下簡稱「乙方」)之機密資料，為保護乙方權益，本公司聲明如下：<br />
                </p>
                <ol>
                  <li>
                    本聲明中所稱之「機密資料」，係指乙方揭露予甲方的機密資料，不論其交付或揭露之方式係以書面、口頭或是以電子形式交付者，均屬之。若乙方提供之文件、資料上或物件，有標示「機密」、「保密」、「限閱」或「Confidential」字樣或其他同義字樣，或乙方告知甲方其為機密資料者，亦均屬機密資料。上述機密資料包括但不限於乙方產品之電子檔案、規格、圖形、成本、製程、供應商、業務規劃或財務資料等，或其他與乙方之生產、人事、財務、管理、採購、業務、行銷計畫、銷貨或產品發展計畫、發明、發現、研究、know-how、流程、作業、客戶、價格或定價政策、供應商或營運策略等相關之資訊或構想。乙方依契約、法令或信託等所持有之他人機密資料，亦視為本聲明之機密資料，甲方知悉或使用該機密資料的，亦應遵守本聲明之規定。又業務往來及本聲明之簽訂信息與條款內容亦屬本聲明所稱之機密資料。
                  </li>
                  <li>
                    甲方同意確實保守機密資料，並僅<strong
                      style="text-decoration: underline"
                      >為商討、評估及執行雙方之間關於現有或未來業務往來合作（以下簡稱「目的」）</strong
                    >使用機密資料。除本聲明另有規定外，非經乙方事前書面同意，甲方絕不洩漏、複製、進行逆向工程、解碼、解譯、分解、告知、交付或以任何其他方式移轉機密資料予任何第三人。甲方同意以其管理自己之機密資料之注意義務（但不得低於善良管理人之注意義務）並採取一切必要措施維護機密資料之機密及安全。
                  </li>
                  <li>
                    如甲方依政府機關合法之命令或法院之判決或命令而須揭露機密資料時，甲方應於合理之期間前，以書面通知乙方，並應協助乙方為一切必要之防禦行為及採取任何降低或減少損害或較為有利之其他保密措施，且僅可依判決或命令所要求最小的範圍內揭露機密資料。
                  </li>
                  <li>
                    甲方得將機密資料揭露予其為執行該目的而有必要知悉機密資料之相關人員（包括但不限於甲方之董事、受雇人及顧問），但甲方應與上述人員簽訂足以保護機密資料之保密合約，且其保密義務不得低於本聲明之要求，始得揭露機密資料予上述人員，且僅得於因履行該目的之範圍而有必要之情形始得揭露予上述人員。
                  </li>
                  <li>
                    乙方交付予甲方之機密資料，其所有權仍歸乙方所有，甲方不得任意處分之，而本聲明之簽訂並不構成任何關於機密資料上所有之專利權、著作權、商標權、光罩著作權、電路佈局權、營業秘密或其他智慧財產權之明示或暗示之授權或移轉。甲方於業務往來終止或屆滿時或經乙方請求時，應立即將所有機密資料及其備份交還乙方或其指定之人，並辦妥乙方所要求之一切手續。
                  </li>
                  <li>
                    本聲明若有修訂或補充之必要，應以書面為之，並應經雙方合法授權代表簽署後始生效力。
                  </li>
                  <li>
                    本聲明之解釋與適用，悉依中華民國法律為準據，若因本聲明發生爭訟時，雙方同意以高雄地方法院為第一審管轄法院。甲方同意其有任何違約情事，將使乙方遭致無法回復之重大損失。如有任何違約之情事，甲方同意(1)賠償乙方懲罰性違約金新台幣100,000元及乙方所有損失；及(2)乙方得以保全程序或其他相同效果之方式於任何法院，就甲方之違約情事，為救濟行為之請求與執行。
                  </li>
                  <li>
                    本聲明即日起有效，至雙方同意該目的已結束或失效。惟甲方之保密義務將持續有效，不受本聲明之終止所影響。
                  </li>
                  <li>
                    本聲明構成雙方對本聲明主題的完整協定，取代雙方之前對本主題的所有溝通、協商及協議。本聲明如有任何條款被法院認定無效，則該條款將被刪除，其他條款繼續有效。
                  </li>
                  <li>
                    任一方不因本聲明之生效而產生任何義務提供資訊、進行任何交易或合作。雙方亦不因本聲明之生效而成為代理、合夥或合資法律關係。
                  </li>
                </ol>
              </template>
              <template v-else-if="language === 'CH'">
                <h4 class="text-center">供应商保密义务声明</h4>
                <p style="text-indent: 2em;">
                  基于双方间业务往来之目的（以下简称「业务往来」），而本公司(以下简称「甲方」)取得瑞仪<span
                    v-if="form.factoryId === 'SZ'"
                    >光电(苏州)</span
                  ><span v-else-if="form.factoryId === 'NJ'">光电(南京)</span
                  ><span v-else>(广州)光电子器件</span
                  >有限公司(以下简称「乙方」)之机密资料，为保护乙方权益，本公司声明如下：
                </p>
                <ol>
                  <li>
                    本声明中所称之「机密资料」，系指乙方揭露予甲方的机密资料，不论其交付或揭露之方式系以书面、口头或是以电子形式交付者，均属之。若乙方提供之文件、资料上或物件，有标示「机密」、「保密」、「限阅」或「Confidential」字样或其他同义字样，或乙方告知甲方其为机密资料者，亦均属机密资料。上述机密资料包括但不限于乙方产品之电子档案、规格、图形、成本、制程、供应商、业务规划或财务资料等，或其它与乙方之生产、人事、财务、管理、采购、业务、营销计划、销货或产品发展计划、发明、发现、研究、know-how、流程、作业、客户、价格或定价政策、供应商或营运策略等相关之信息或构想。乙方依契约、法令或信托等所持有之他人机密资料，亦视为本声明之机密资料，甲方知悉或使用该机密资料的，亦应遵守本声明之规定。又业务往来及本声明之签订信息与条款内容亦属本声明所称之机密资料。
                  </li>
                  <li>
                    甲方同意确实保守机密资料，并仅<strong
                      style="text-decoration: underline"
                      >为商讨、评估及执行双方之间关于现有或未来业务往来合作（以下简称「目的」）</strong
                    >使用机密资料。除本声明另有规定外，非经乙方事前书面同意，甲方绝不泄漏、复制、进行逆向工程、译码、解译、分解、告知、交付或以任何其它方式移转机密资料予任何第三人。甲方同意以其管理自己之机密资料之注意义务（但不得低于善良管理人之注意义务）并采取一切必要措施维护机密资料之机密及安全。
                  </li>
                  <li>
                    如甲方依政府机关合法之命令或法院之判决或命令而须揭露机密资料时，甲方应于合理之期间前，以书面通知乙方，并应协助乙方为一切必要之防御行为及采取任何降低或减少损害或较为有利之其它保密措施，且仅可依判决或命令所要求的最小范围内揭露机密资料。
                  </li>
                  <li>
                    甲方得将机密资料揭露予其为执行该目的而有必要知悉机密资料之相关人员（包括但不限于甲方之董事、受雇人及顾问），但甲方应与上述人员签订足以保护机密资料之保密合约，且其保密义务不得低于本声明之要求，始得揭露机密资料予上述人员，且仅得于因履行该目的之范围而有必要之情形始得揭露予上述人员。
                  </li>
                  <li>
                    乙方交付予甲方之机密资料，其所有权仍归乙方所有，甲方不得任意处分之，而本声明之签订并不构成任何关于机密资料上所有之专利权、著作权、商标权、光罩著作权、电路布局权、营业秘密或其它智慧财产权之明示或暗示之授权或移转。甲方于业务往来终止或届满时或经乙方请求时，应立即将所有机密资料及其备份交还乙方或其指定之人，并办妥乙方所要求之一切手续。
                  </li>
                  <li>
                    本声明若有修订或补充之必要，应以书面为之，并应经双方合法授权代表签署后始生效力。
                  </li>
                  <li>
                    本声明之解释与适用，悉依中华人民共和国法律为准据，若因本声明发生争讼时，双方同意以甲方所在地法院为第一审管辖法院。甲方同意其有任何违约情事，将使乙方遭致无法回复之重大损失。如有任何违约之情事，甲方同意（1）赔偿乙方违约金人民币100,000元及乙方所有损失；及（2）乙方得以保全程序或其它相同效果之方式于任何法院，就甲方之违约情事，为救济行为之请求与执行。
                  </li>
                  <li>
                    本声明即日起有效，至双方同意该目的已结束或失效。惟甲方之保密义务将持续有效，不受本声明之终止所影响。
                  </li>
                  <li>
                    本声明构成双方对本声明主题的完整协议，取代双方之前对本主题的所有沟通、协商及协议。本声明如有任何条款被法院认定无效，则该条款将被删除，其它条款继续有效。
                  </li>
                  <li>
                    任一方不因本声明之生效而产生任何义务提供信息、进行任何交易或合作。双方亦不因本声明之生效而成为代理、合伙或合资法律关系。
                  </li>
                </ol>
              </template>

              <template v-else-if="language === 'VH'">
                <h4 class="text-center">Undertaking of Non-disclosure</h4>
                <p style="text-indent: 2em;">
                  We (“Recipient”) irrevocably and unequivocally warrant and undertake to strictly comply with the following terms and conditions for consideration which we agree to be valuable and adequate:(Radiant and Recipient are hereinafter referred to as respectively the“Party”and collectively the“Parties”)
                </p>
                <ol class="vh_ol">
                  <!-- 1. -->
                  <li>
                    <strong style="margin-left: 1em;text-decoration: underline">Definition of Confidential Information</strong>

                    <ol class="vh_ol">
                      <li class="indent-title-2">
                        For the purpose of this Undertaking, “Confidential Information” means any data or information that is proprietary to or within the control of Radiant and not generally known to the public, whether orally, visually, in writing or in tangible or intangible form, whenever and howsoever disclosed, including but not limited to:
                      
                        <br>
                        <span>
                          <span class="title-mark">(i)</span>
                          any scientific or technical information, formulae, standard operating procedure, process, procedure, inventions, know-how, works-in-progress, designs, development tools, specifications, software, source code, database, trade secrets, concepts, ideas, methods, strategies, diagrams, models, drawings, design, research, development, unpublished patent applications, invention disclosures, software codes of any kind, employee information, lists of business partners and customers ;
                        </span>
                      
                        <br>
                        <span>
                          <span class="title-mark">(ii)</span>
                          information relating to Radiant’s marketing, pricing, sales plans, procurement, product development, forecast, human resource, finance, business, customers, corporate strategies;
                        </span>

                        <br>
                        <span>
                          <span class="title-mark">(iii)</span>
                          information received by Radiant pursuant to laws or any information which Radiant obtains from a third party and treats confidentially;
                        </span>

                        <br>
                        <span>
                          <span class="title-mark">(iv)</span>
                          any information marked “Confidential”; and 
                        </span>

                        <br>
                        <span>
                          <span class="title-mark">(v)</span>
                          any other information which can be reasonably recognized as confidential information.
                        </span>

                        <br>
                        <span>If there is ever any doubt as to whether any received information is Confidential Information, Recipient shall treat it as Confidential Information until clarified in writing by Radiant. Furthermore, without the prior written consent of Radiant, in no circumstances may Recipient disclose all discussions take place between the Parties with respect to the Purpose.</span>

                      </li>

                      <li class="indent-title-2">Recipient agrees that all Confidential Information shall be and remain the sole property of Radiant.  Radiant shall be the sole owner of all rights, title, patents, copyrights, trademarks and other proprietary rights in connection therewith and that no license is granted, assigned or implied to be granted to Recipient.</li>
                    </ol>
                  </li>
                  <br>

                  <!-- 2. -->
                  <li>
                    <strong style="margin-left: 1em;text-decoration: underline">Duty of Confidentiality</strong>

                    <ol class="vh_ol">
                      <li class="indent-title-2">
                        Confidential Information shall only be used for the purpose of discussing, evaluating, executing
                        <strong style="text-decoration: underline">potential, existing and future business cooperation or transactions between Radiant and Recipient only</strong>
                        (“Purpose”). Recipient may disclose Confidential Information to its employees strictly on need-to-know basis only, provided that such employees have executed non-disclosure agreements with duty to maintain confidentiality no less stringent than that provided herein.  Recipient is not permitted to:
                      
                        <br>
                        <span>
                          <span class="title-mark">(i)</span>
                          use, reverse engineer, decompile, disassemble, copy or disclose Confidential Information or any information derived therefrom, to any other persons without prior written approval from Radiant.
                        </span>

                        <br>
                        <span>
                          <span class="title-mark">(ii)</span>
                          disclose Confidential Information to any person or entity except for those permitted as above-mentioned in Article 2.1;
                        </span>

                        <br>
                        <span>
                          <span class="title-mark">(iii)</span>
                          use Confidential Information for any purpose other than the evaluation ,testing or fulfilling necessary for the Purpose;
                        </span>

                        <br>
                        <span>
                          <span class="title-mark">(iv)</span>
                          reproduce or summarize Confidential Information in any form except to the minimum extent necessary for the Purpose, provided that Recipient shall mark such copies, reproductions and summaries of Confidential Information with the legend “confidential” or an equivalent designation.
                        </span>
                      
                      </li>

                      <li class="indent-title-2">Recipient shall keep Confidential Information as strictly confidential by using the same degree of care applied by Recipient in safeguarding its own confidential information, but in no event shall be less than reasonable degree of care.</li>
                    
                      <li class="indent-title-2">In the event that Recipient is required by laws, regulations, or orders of courts, governmental or administrative bodies to disclose Confidential Information, Recipient shall immediately inform Radiant, and shall assist Radiant to obtain protective order or relief. Recipient may disclose Confidential Information only to the minimum extent required by the laws, regulations or orders.</li>
                    </ol>
                  </li>
                  <br>

                  <!-- 3. -->
                  <li class="indent-title-2">
                    <strong style="margin-left: 1em;text-decoration: underline">Term</strong>

                    <br>
                    This Undertaking shall remain in effect f until Parties agree in writing that the Purpose is no longer valid. (“Term”)  Notwithstanding the foregoing, Recipient’s obligation to maintain confidentiality for information disclosed during the Term shall remain effective indefinitely.
                  </li>
                  <br>

                  <!-- 4. -->
                  <li class="indent-title-2">
                    <strong style="margin-left: 1em;text-decoration: underline">Remedies</strong>
                    
                    <br>
                    Recipient agrees that Confidential Information to be disclosed hereunder is of a unique nature and valuable character, and that any unauthorized dissemination of the Confidential Information would cause irreparable harm to Radiant. Therefore, in the event Recipient violates any of the terms hereof, Radiant shall be entitled to: (a)
                    <strong>VND 350,000,000</strong>
                    compensation (in addition to expenses, costs (including reasonably attorney fees) and damages incurred by Radiant); and (b) injunctive relief to preventing dissemination of any Confidential Information without posting bonds.
                  </li>
                  <br>

                  <!-- 5. -->
                  <li>
                    <strong style="margin-left: 1em;text-decoration: underline">Return, Destruction or Erasure of Confidential Information</strong>

                    <ol class="vh_ol">
                      <li class="indent-title-2">
                        Upon termination or expiration of this Undertaking, or upon Radiant’s request, Recipient shall :

                        <br>
                        <span>
                          <span class="title-mark">(i)</span>
                          cease using the Confidential Information;
                        </span>

                        <br>
                        <span>
                          <span class="title-mark">(ii)</span>
                          promptly return, destroy or erase all Confidential Information (including copies) in accordance with Radiant’s instruction within seven (7) days upon request by Radiant at Recipient’s cost;
                        </span>

                        <br>
                        <span>
                          <span class="title-mark">(iii)</span>
                          destroy any records of the Confidential Information.
                        </span>

                      </li>

                      <li class="indent-title-2">
                        If so requested by Radiant, Recipient shall within three (3) days upon receiving Radiant’s request certify in writing or prove that it has acceded to Radiant’s request by submitting written evidence and/or a certification signed by a duly authorized representative of Recipient to Radiant in accordance with Radiant’s direction.
                      </li>
                    </ol>
                  </li>
                  <br>

                  <!-- 6. -->
                  <li>
                    <strong style="margin-left: 1em;text-decoration: underline">Ownership</strong>

                    <ol class="vh_ol">
                      <li class="indent-title-2">
                        Radiant shall have and retain all right, title, and interest in and to Confidential Information.  Nothing in this Undertaking will be construed to grant or confer upon Recipient any right, title, interest, or license in any intellectual property rights or Confidential Information without prior consent of Radiant.
                      </li>

                      <li class="indent-title-2">
                        Neither this Undertaking nor any conduct of the Parties under this Undertaking shall be construed in any way as granting, whether explicitly or implicitly, any license ,right or interest of any kind in any patent, patent applications, copyright, trade secrets, know-how, inventions, ideas, algorithms, processes, operations, techniques, designs, schematics, sketches, drawings, trademarks, service marks, trade names or other intellectual property rights except for the limited rights to receive, use and disclose Confidential Information expressly granted to Recipient under this Undertaking.
                      </li>
                    </ol>
                  </li>
                  <br>

                  <!-- 7. -->
                  <li>
                    <strong style="margin-left: 1em;text-decoration: underline">No Warranty</strong>

                    <ol class="vh_ol">
                      <li class="indent-title-2">
                        Radiant warrants that it has the right to disclose the Confidential Information to Recipient. However, all information is provided "AS IS" and without any warranty, express, implied or otherwise, regarding its accuracy or performance.
                      </li>
                    </ol>
                  </li>
                  <br>

                  <!-- 8. -->
                  <li>
                    <strong style="margin-left: 1em;text-decoration: underline">Governing Law and Dispute Settlement</strong>

                    <ol class="vh_ol">
                      <li class="indent-title-2">
                        This Undertaking shall be governed, construed and interpreted in accordance with the laws of Socialist Republic of Vietnam, excluding its conflict of laws provisions.
                      </li>

                      <li class="indent-title-2">
                        All actions or proceedings relating to this Undertaking shall be non-exclusively subject to the jurisdiction of the location of Radiant district court and its superior courts.
                      </li>
                    </ol>
                  </li>
                  <br>

                  <!-- 9. -->
                  <li>
                    <strong style="margin-left: 1em;text-decoration: underline">Miscellaneous</strong>

                    <ol class="vh_ol">
                      <li class="indent-title-2">
                        Parties are not obliged by this Undertaking to provide any information, or enter into any business cooperation, sale, transfer or any kind of transaction. This Undertaking does not create any joint venture, partnership, principle-agent relationship between the Parties.
                      </li>

                      <li class="indent-title-2">
                        Recipient (whether directly or indirectly through its affiliates or subsidiaries) shall not solicit or hire any employees of Radiant during the Term and
                        <strong style="text-decoration: underline"> two (2) </strong>
                        years thereafter regardless of termination or expiration of this Undertaking.
                      </li>

                      <li class="indent-title-2">
                        This Undertaking constitutes the entire Undertaking and supersedes all earlier discussion, understanding or Undertaking between the Parties regarding the subject matter herein.
                      </li>

                      <li class="indent-title-2">
                        <strong style="text-decoration: underline">Waiver</strong>
                        : The failure of either Party hereto at any time to require performance by the other Party of any responsibility or obligation hereunder shall in no way affect the full right to require such performance at any time thereafter. Nor shall the waiver by either Party of a breach of any provision hereof constitute a waiver of any succeeding breach of the same or any other provision hereof or constitute a waiver of the responsibility or obligation itself.
                      </li>

                      <li class="indent-title-2">
                        <strong style="text-decoration: underline">Severability</strong>
                        : If any provision of this Undertaking is found by a court of competent jurisdiction to be unenforceable, such provision shall be segregated from this Undertaking.  The remainder of this Undertaking will be enforced as if such provision was not included.
                      </li>

                      <li class="indent-title-2">
                        <strong style="text-decoration: underline">Headings</strong>
                        : Paragraph headings used in this Undertaking are for reference only and shall not be used or relied upon in the interpretation of this Undertaking.
                      </li>

                      <li class="indent-title-2">
                        <strong style="text-decoration: underline">Entire Undertaking</strong>
                        : This Undertaking constitutes the entire and sole Undertaking between the Parties and supersedes all previous negotiations, discussions, Undertakings and commitments with respect to the Purpose hereof. This Undertaking shall not be amended, altered, changed or modified in any manner, except by an instrument signed by the duly authorized representative of each Party, and shall not be modified except with the consent of both Parties in writing.
                      </li>
                    </ol>
                  </li>
                  <br>

                </ol>

              </template>
            </div>
            <div class="modal-footer">
              <div class="checkbox-item">
                <el-checkbox v-model="checked">
                  <span v-if="language === 'VH'">Agree NDA</span>
                  <span v-else>同意NDA內容</span>
                </el-checkbox>
                <span v-if="errorMessage" class="warning">
                  <span v-if="language === 'VH'">Please tick to agree</span>
                  <span v-else-if="language === 'CH'">请勾选同意</span>
                  <span v-else>請勾選同意</span>
                </span>
              </div>
              <button
                type="button"
                class="btn btn-secondary"
                data-dismiss="modal"
                @click="form.applicationPurpose = null; cancel = true"
              >
                <span v-if="language === 'VH'">Cancel</span>
                <span v-else>取消</span>
              </button>
              <button type="button" class="btn btn-primary" @click="agree">
                <span v-if="language === 'VH'">Accept</span>
                <span v-else-if="language === 'CH'">确定</span>
                <span v-else>確定</span>
              </button>
            </div>
          </div>
        </div>
      </div>

      <div
        style="
          font-size: 0.9em;
          background-color: #ffeded;
          display: inline-block;
          padding: 3px 10px;
          border-radius: 5px;
          margin-bottom: 10px;
        "
      >
        {{ isVietnam ? 'Vui lòng tải lên giấy phép kinh doanh/giấy chứng nhận đăng ký kinh doanh của bạn / Please upload your business license/business registration certificate' : '請上傳營業執照/營業登記證 / Please upload your business license/business registration certificate' }}
      </div>

      <el-form-item label="已上傳檔案" v-if="!isNew">
        <ul class="uploaded-file-list">
          <li
            v-for="(file, index) in form.nonQualificationVendorFileDetails"
            :key="file.guid"
          >
            <div class="link" @click="downloadFile(file)">
              <i class="el-icon-paperclip"></i>
              {{ file.fileName }}
              <span style="opacity: 0.5; margin-left: 10px"
                >{{ (file.fileBytes / 1024 / 1024).toFixed(2) }}mb</span
              >
            </div>
            <el-button
              class="delete-btn"
              type="danger"
              icon="el-icon-delete"
              circle
              @click.prevent="removeFile(index, file)"
            ></el-button>
          </li>
        </ul>
      </el-form-item>

      <el-upload
        ref="upload"
        accept=".gif,.png,.jpg,.doc,.xls,.ppt,.docx,.xlsx,.pptx,.pdf"
        action
        multiple
        :auto-upload="false"
        :show-file-list="false"
        :file-list="form.files"
        :on-change="fileChange"
      >
        <el-button size="small" type="primary">{{ isVietnam ? 'Thêm tập tin mới / Add new file' : '新增檔案 / Add new file' }}</el-button>
      </el-upload>

      <el-form-item>
        <ul class="uploaded-file-list">
          <li v-for="(file, index) in form.files" :key="file.uid">
            <a>
              <i class="el-icon-paperclip"></i>
              {{ file.name }}
              <span style="opacity: 0.5; margin-left: 10px"
                >{{ (file.size / 1024 / 1024).toFixed(2) }}mb</span
              >
            </a>
            <el-button
              class="delete-btn"
              type="danger"
              icon="el-icon-delete"
              circle
              @click.prevent="removeNewFile(index)"
            ></el-button>
          </li>
        </ul>
      </el-form-item>

      <div style="text-align: center">
        <el-button v-if="isNew" type="primary" @click="submitForm('form')"
          >{{ isVietnam ? 'Gửi đi / Send out' : '送出 / Send out' }}</el-button
        >
        <el-button v-if="!isNew" type="primary" @click="resubmitForm('form')"
          >重送</el-button
        >
      </div>
    </el-form>

    <el-dialog :title="isVietnam ? 'gợi ý / tip' : '提示 / tip'" :visible.sync="dialogVisible" width="40%">
      <ul>
        <li v-if="novalidList.find((element) => element === 'radiantUserName')">
          {{ 
            form.applicationPurpose === '0'
              ? isVietnam ? 'Chưa điền tên nhân viên liên hệ của công ty quang điện tử Thụy Nghi / ROE purcher name is blank' : '瑞儀採購人員姓名 / ROE purcher name is blank'
              : isVietnam ? 'Chưa điền tên nhân viên liên hệ của công ty quang điện tử Thụy Nghi / ROE engineer name is blank' : '瑞儀工程師姓名 / ROE engineer name is blank'
          }}
        </li>
        <li
          v-if="novalidList.find((element) => element === 'radiantUserNameExt')"
        >
          {{ isVietnam ? 'Chưa điền số máy nhánh / Extension  number is blank' : '分機號碼未填 / Extension  number is blank' }}
        </li>
        <li
          v-if="novalidList.find((element) => element === 'applicationPurpose')"
        >
          {{ isVietnam ? 'Chưa điền mục đích đăng kí / Application purpose is blank' : '申請目的未填 / Application purpose is blank' }}
        </li>
        <li v-if="novalidList.find((element) => element === 'vendorName')">
          {{ isVietnam ? 'Chưa điền tên nhà máy / Vendor name is blank' : '廠商名稱未填 / Vendor name is blank' }}
        </li>
        <li v-if="novalidList.find((element) => element === 'taxId')">
          {{ isVietnam ? 'Chưa điền số thống nhất (mã số thuế) / Unified number is blank' : '統一編號(稅籍編號)未填 / Unified number is blank' }}
        </li>
        <li v-if="novalidList.find((element) => element === 'vendorTelephone')">
          {{ isVietnam ? 'Chưa điền số điện thoại công ty / Company phone is blank' : '公司電話未填 / Company phone is blank' }}
        </li>
        <li v-if="novalidList.find((element) => element === 'vendorAddress')">
          {{ isVietnam ? 'Chưa điền địa chỉ công ty / Company address is blank' : '公司地址未填 / Company address is blank' }}
        </li>
        <li v-if="novalidList.find((element) => element === 'invoiceAddress')">
          {{ isVietnam ? 'Chưa điền địa chỉ hóa đơn / Invoice address is blank' : '發票地址未填 / Invoice address is blank' }}
        </li>
        <li v-if="novalidList.find((element) => element.match('userName'))">
          {{ isVietnam ? 'Chưa điền họ tên / Name is blank' : '姓名未填 / Name is blank' }}
        </li>
        <li v-if="novalidList.find((element) => element.match('userE_Mail'))">
          {{ isVietnam ? ' Chưa điền hộp thư hoặc định dạng sai / E-mail is blank or format is wrong' : '信箱未填或格式錯誤 / E-mail is blank or format is wrong' }}
        </li>

        <!-- <template v-for="(email,index) in form.nonQualificationVendorDetails">
          <li :key="index+`name`" v-if="novalidList.find(nonQualificationVendorDetails.0.userE_Mail)">姓名未填 {{index}}</li>
          <li :key="index+`mail`" v-if="novalidList`.${nonQualificationVendorDetails.index.userE_Mail}`">Email未填或格式錯誤</li>
        </template> -->
      </ul>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">{{ isVietnam ? 'đóng cửa / Close' : '關閉 / Close' }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { Notification } from "element-ui";
import { mapGetters } from "vuex";
import $ from "jquery";

export default {
  data() {
    return {
      fullscreenLoading: false,
      isNew: null,
      dialogVisible: false,
      novalidList: [], //驗證失敗的欄位
      form: {
        files: [],
        factoryId: null,
        nonQualificationVendorDetails: [
          {
            sno: 0,
            userName: null,
            userE_Mail: null,
          },
        ],
      },

      checked: false,
      language: "TW",
      isVietnam: false,
      errorMessage: false,
      //guid: "1656419e-4498-469d-b5ab-6b92ece47ed1",
    };
  },
  computed: {
    ...mapGetters(["lang"]),
    headerText() {
      if (this.isEdit) {
        if (this.lang === "en") {
          return "Edit Information";
        } else {
          return "修改資訊";
        }
      } else {
        if (this.lang === "en") {
          return "Add bidding";
        } else {
          return "新增資訊";
        }
      }
    },
    VersionText() {   //  版本顯示
      const vm = this;

      if(vm.form.factoryId === "KH" || vm.form.factoryId === "KW") return "台灣版本";
      if(vm.form.factoryId === "SZ" || vm.form.factoryId === "NJ" || vm.form.factoryId === "GZ") return "大陸版本";
      if(vm.form.factoryId === "VH") return "Phiên bản việt nam";
    },
  },
  methods: {
    getData(guid) {
      const vm = this;
      const api = `${this.$baseApiUrl}/NonQualificationVendor/GetNonQualificationVendor/${guid}`;

      vm.axios.get(api).then((response) => {
        vm.form = {
          ...response.data,
          files: response.data.files ? response.data.files : [],
        };
      });
    },

    removeEmail(index) {
      const vm = this;
      vm.form.nonQualificationVendorDetails.splice(index, 1);
    },

    addEmail() {
      const vm = this;
      let newData = {
        sno: 0,
        userName: null,
        userE_Mail: null,
      };

      vm.form.nonQualificationVendorDetails.push(newData);
    },

    // 匯入資料 API
    fileChange(file, fileList) {
      const vm = this;
      let oldTotal = 0;
      let newTotal = 0;
      if (vm.form.nonQualificationVendorFileDetails) {
        vm.form.nonQualificationVendorFileDetails.forEach((item) => {
          oldTotal += item.fileBytes;
        });
      }

      if (vm.form.files) {
        vm.form.files.forEach((item) => {
          newTotal += item.size;
        });
      }

      const isLt20M = (oldTotal + newTotal + file.size) / 1024 / 1024 < 20;

      if (!isLt20M) {
        this.$message.error("檔案總大小不得超過 20MB!");
        return;
      } else {
        if (vm.form.files) {
          vm.form.files.push(file);
        } else {
          vm.form.files = [];
          vm.form.files.push(file);
        }
      }
    },
    downloadFile(file) {
      const vm = this;
      const api = `${this.$baseApiUrl}/NonQualificationVendor/GetFile/${file.guid}`;

      vm.axios.get(api, { responseType: "blob" }).then((response) => {
        let blob = new Blob([response.data]);
        let url = window.URL.createObjectURL(blob);
        let link = document.createElement("a");
        link.href = url;
        link.download = file.fileName;
        link.click();

        window.URL.revokeObjectURL(url);
      });
    },

    removeFile(index, file) {
      const vm = this;
      if (vm.form.deleteFileDetails) {
        vm.form.deleteFileDetails.push({
          guid: file.guid,
          fileName: file.fileName,
        });
      } else {
        vm.form.deleteFileDetails = [];
        vm.form.deleteFileDetails.push({
          guid: file.guid,
          fileName: file.fileName,
        });
      }

      vm.form.nonQualificationVendorFileDetails.splice(index, 1);
    },

    removeNewFile(index) {
      const vm = this;
      vm.form.files.splice(index, 1);
    },

    // 同意 NDA
    agree() {
      this.cancel = false;
      if (!this.checked) {
        this.errorMessage = true;
        return;
      } else {
        $("#contractModal").modal("hide");
      }
    },

    //送出新的
    submitForm(formName) {
      const vm = this;

      vm.$refs[formName].validate((valid, object) => {
        if (valid) {
          vm.fullscreenLoading = true;
          const api = `${vm.$baseApiUrl}/NonQualificationVendor/Add`;
          const formData = new FormData();

          let CreateUser = vm.form.createUser ? vm.form.createUser : null;
          CreateUser ? formData.append("CreateUser", CreateUser) : null;

          let FactoryId = vm.form.factoryId ? vm.form.factoryId : null;
          FactoryId ? formData.append("FactoryId", FactoryId) : null;

          let RadiantUserName = vm.form.radiantUserName
            ? vm.form.radiantUserName
            : null;
          RadiantUserName
            ? formData.append("RadiantUserName", RadiantUserName)
            : null;

          let RadiantUserNameExt = vm.form.radiantUserNameExt
            ? vm.form.radiantUserNameExt
            : null;
          RadiantUserNameExt
            ? formData.append("RadiantUserNameExt", RadiantUserNameExt)
            : null;

          let ApplicationPurpose = vm.form.applicationPurpose
            ? vm.form.applicationPurpose
            : null;
          ApplicationPurpose
            ? formData.append("ApplicationPurpose", ApplicationPurpose)
            : null;

          let VendorName = vm.form.vendorName ? vm.form.vendorName : null;
          VendorName ? formData.append("VendorName", VendorName) : null;

          let TaxId = vm.form.taxId ? vm.form.taxId : null;
          TaxId ? formData.append("TaxId", TaxId) : null;

          let VendorTelephone = vm.form.vendorTelephone
            ? vm.form.vendorTelephone
            : null;
          VendorTelephone
            ? formData.append("VendorTelephone", VendorTelephone)
            : null;

          let VendorAddress = vm.form.vendorAddress
            ? vm.form.vendorAddress
            : null;
          VendorAddress
            ? formData.append("VendorAddress", VendorAddress)
            : null;

          let InvoiceAddress = vm.form.invoiceAddress
            ? vm.form.invoiceAddress
            : null;
          InvoiceAddress
            ? formData.append("InvoiceAddress", InvoiceAddress)
            : null;

          let NonQualificationVendorDetails = vm.form
            .nonQualificationVendorDetails
            ? vm.form.nonQualificationVendorDetails
            : null;

          if (NonQualificationVendorDetails) {
            for (var n = 0; n < NonQualificationVendorDetails.length; n++) {
              formData.append(
                "NonQualificationVendorDetails[" + n + "][sno]",
                n + 1
              );
              formData.append(
                "NonQualificationVendorDetails[" + n + "][userName]",
                NonQualificationVendorDetails[n].userName
              );
              formData.append(
                "NonQualificationVendorDetails[" + n + "][userE_Mail]",
                NonQualificationVendorDetails[n].userE_Mail
              );
            }
          }

          let Files = vm.form.files ? vm.form.files : null;

          if (Files) {
            for (var j = 0; j < Files.length; j++) {
              formData.append("Files", Files[j].raw);
            }
          }

          vm.axios
            .post(api, formData, {
              headers: { "Content-Type": "multipart/form-data" },
            })
            .then((response) => {
              vm.fullscreenLoading = false;
              if (response.status === 200) {
                if (response.data.errorMessage) {
                  Notification({
                    title: "失敗",
                    message: response.data.errorMessage,
                    type: "error",
                    duration: 5000,
                  });
                } else {
                  this.$router.push("NonQualificationVendorComplete");
                }
              }
            })
            .catch(() => {
              vm.fullscreenLoading = false;
            });
        } else {
          vm.fullscreenLoading = false;
          vm.dialogVisible = true;
          vm.novalidList = Object.getOwnPropertyNames(object);
          return false;
        }
      });
    },

    //重送
    resubmitForm(formName) {
      const vm = this;

      vm.$refs[formName].validate((valid, object) => {
        if (valid) {
          vm.fullscreenLoading = true;
          const api = `${vm.$baseApiUrl}/NonQualificationVendor/ReApply`;
          const formData = new FormData();

          let Guid = vm.form.guid ? vm.form.guid : null;
          Guid ? formData.append("Guid", Guid) : null;

          let DeleteFileDetails = vm.form.deleteFileDetails
            ? vm.form.deleteFileDetails
            : null;

          if (DeleteFileDetails) {
            for (var i = 0; i < DeleteFileDetails.length; i++) {
              formData.append(
                "DeleteFileDetails[" + i + "][guid]",
                DeleteFileDetails[i].guid
              );
              formData.append(
                "DeleteFileDetails[" + i + "][fileName]",
                DeleteFileDetails[i].fileName
              );
            }
          }

          // ? formData.append("DeleteFileDetails",DeleteFileDetails)
          // : null;

          let FactoryId = vm.form.factoryId ? vm.form.factoryId : null;
          FactoryId ? formData.append("FactoryId", FactoryId) : null;

          let RadiantUserName = vm.form.radiantUserName
            ? vm.form.radiantUserName
            : null;
          RadiantUserName
            ? formData.append("RadiantUserName", RadiantUserName)
            : null;

          let RadiantUserNameExt = vm.form.radiantUserNameExt
            ? vm.form.radiantUserNameExt
            : null;
          RadiantUserNameExt
            ? formData.append("RadiantUserNameExt", RadiantUserNameExt)
            : null;

          let ApplicationPurpose = vm.form.applicationPurpose
            ? vm.form.applicationPurpose
            : null;
          ApplicationPurpose
            ? formData.append("ApplicationPurpose", ApplicationPurpose)
            : null;

          let VendorName = vm.form.vendorName ? vm.form.vendorName : null;
          VendorName ? formData.append("VendorName", VendorName) : null;

          let TaxId = vm.form.taxId ? vm.form.taxId : null;
          TaxId ? formData.append("TaxId", TaxId) : null;

          let VendorTelephone = vm.form.vendorTelephone
            ? vm.form.vendorTelephone
            : null;
          VendorTelephone
            ? formData.append("VendorTelephone", VendorTelephone)
            : null;

          let VendorAddress = vm.form.vendorAddress
            ? vm.form.vendorAddress
            : null;
          VendorAddress
            ? formData.append("VendorAddress", VendorAddress)
            : null;

          let InvoiceAddress = vm.form.invoiceAddress
            ? vm.form.invoiceAddress
            : null;
          InvoiceAddress
            ? formData.append("InvoiceAddress", InvoiceAddress)
            : null;

          let NonQualificationVendorDetails = vm.form
            .nonQualificationVendorDetails
            ? vm.form.nonQualificationVendorDetails
            : null;

          if (NonQualificationVendorDetails) {
            for (var n = 0; n < NonQualificationVendorDetails.length; n++) {
              formData.append(
                "NonQualificationVendorDetails[" + n + "][sno]",
                n + 1
              );
              formData.append(
                "NonQualificationVendorDetails[" + n + "][userName]",
                NonQualificationVendorDetails[n].userName
              );
              formData.append(
                "NonQualificationVendorDetails[" + n + "][userE_Mail]",
                NonQualificationVendorDetails[n].userE_Mail
              );
            }
          }

          let Files = vm.form.files ? vm.form.files : null;

          if (Files) {
            for (var j = 0; j < Files.length; j++) {
              formData.append("Files", Files[j].raw);
            }
          }

          //   Files ? formData.append("Files", Files) : null;

          vm.axios
            .post(api, formData, {
              headers: { "Content-Type": "multipart/form-data" },
            })
            .then((response) => {
              vm.fullscreenLoading = false;
              if (response.status === 200) {
                if (response.data.errorMessage) {
                  Notification({
                    title: "失敗",
                    message: response.data.errorMessage,
                    type: "error",
                    duration: 5000,
                  });
                } else {
                  this.$router.push("NonQualificationVendorComplete");
                }
              }
            })
            .catch(() => {
              vm.fullscreenLoading = false;
            });
        } else {
          vm.fullscreenLoading = false;
          vm.dialogVisible = true;
          vm.novalidList = Object.getOwnPropertyNames(object);
          return false;
        }
      });
    },

    i18n(keyStr) {
      return this.$t(keyStr);
    },
  },
  mounted() {},

  watch: {
    "form.applicationPurpose": function(newVal) {
      if (newVal === "1") {
        this.cancel = false;
        this.errorMessage = false;
        $("#contractModal").modal("show");
      } else {
        this.checked = false;
      }
    },

    checked: function(newVal) {
      if (!this.cancel) {
        newVal ? (this.errorMessage = false) : (this.errorMessage = true);
      }
    },

    "form.factoryId": function(newVal) {
      if (newVal === "KH" || newVal === "KW") {
        this.language = "TW";
        this.isVietnam = false;
      } else if(newVal === "SZ" || newVal === "NJ" || newVal === "GZ") {
        this.language = "CH";
        this.isVietnam = false;
      } else {
        this.language = "VH";
        this.isVietnam = true;
      }
    },

    lang: function() {
      //   this.tableHeader = [
      //     this.i18n("PurchaseInfoTableHeader.No"),
      //     this.i18n("PurchaseInfoTableHeader.QuotationVendorCode"),
      //     this.i18n("PurchaseInfoTableHeader.QuotationVendor"),
      //     this.i18n("PurchaseInfoTableHeader.E_mail"),
      //     this.i18n("PurchaseInfoTableHeader.QuotationDate"),
      //     this.i18n("PurchaseInfoTableHeader.Quotation"),
      //     this.i18n("PurchaseInfoTableHeader.Currency"),
      //     this.i18n("PurchaseInfoTableHeader.NetAmount"),
      //     this.i18n("PurchaseInfoTableHeader.Memo"),
      //     this.i18n("PurchaseInfoTableHeader.LowestPrice"),
      //   ];
      //   this.factoryList = this.$t("factoryList"); //廠別 清單
      //   this.requestTypeList = this.$t("requestTypeList"); //報價類別 清單
      //   this.requestWayList = this.$t("requestWayList"); //報價方式 清單
      //   this.notifySupervisorList = this.$t("notifySupervisorList"); //是否通知 清單
    },
  },
  created() {
    this.isNew = JSON.parse(sessionStorage.getItem("outerIsNew"));

    if (this.isNew) {
      this.form.factoryId = sessionStorage.getItem("outerFactoryid");
    } else {
      this.getData(sessionStorage.getItem("outerGuid"));
    }
  },
};
</script>

<style lang="scss">
.Non-Qualification-Vendor-Page {
  padding: 60px;

  .form {
    background-color: #fff;
    padding: 30px;
    max-width: 960px;
    margin: 0 auto;

    .uploaded-file-list {
      list-style: none;

      padding: 0;
      li {
        display: flex;
        justify-content: space-between;
        &:nth-child(odd) {
          background-color: #f5f5f5;
        }
        a,
        .link {
          color: #0e52c1;
          cursor: pointer;
        }
      }
      .delete-btn {
        background-color: transparent;
        color: #000;
        border: none;
        transition: all 0.2s;

        &:hover {
          background-color: #f56c6c;
          color: #fff;
        }
      }
    }
    .el-form-item__label {
      border-left: 5px solid rgb(24, 135, 179);
      line-height: unset;
      padding: 0;
      padding-left: 5px;
    }
    .el-row {
      display: flex;
      margin-right: -10px;
      align-items: center;
    }
  }

  #contractModal {
    .modal-dialog-scrollable .modal-content {
      max-height: 95%;
    }
    .modal-footer {
      position: relative;
      .checkbox-item {
        position: absolute;
        margin: 0 auto;
        left: 40px;
        span {
          font-size: 0.9rem;
        }
        .warning {
          color: red;
        }
      }
    }

    .vh_ol {
      counter-reset: item;
      padding-left: 0;
      text-align: justify;

      li {
        display: block;
      }

      li:before {
        content: counters(item, ".") ". ";
        counter-increment: item;
      }

      .title-mark {
        display: inline-block;
        width: 24px;
        margin-right: 4px;

        text-indent: 0em;
      }

      .indent-title-2 {
        text-indent: -2em;
        margin-left: 2em;
      }
    }

    li {
      list-style: cjk-ideographic;
    }
    .el-checkbox:last-of-type {
      margin-right: 10px;
    }
    .el-checkbox__label {
      color: #4e4e4e;
    }
    .el-checkbox__inner {
      border-color: #626262;
    }
    .el-checkbox__input.is-checked .el-checkbox__inner,
    .el-checkbox__input.is-indeterminate .el-checkbox__inner {
      border-color: #626262;
      background-color: #626262;
    }
    .el-checkbox.is-bordered {
      border-color: #626262;
      padding: 8px 10px 6px 10px;
      height: 36px;
    }
  }
}
</style>
